define('shared/util/checkout/PaymentMethodManager',[
    'shared/initializer/form/constants',
    'shared/util/state',
    'shared/util/state/adapters/persistent'
],
function (
    constants,
    state,
    persistentAdapter
) {

    function Ctor() {
        this.useExisting = false;
    }
    Ctor.METHOD_TYPE_NO_CARD = 'no-card';
    Ctor.METHOD_TYPE_EXISTING = 'existing';
    Ctor.METHOD_TYPE_DEFAULT = 'default';
    Ctor.prototype.get = function () {
        var me = this;
        var isDebug = false;
        var useExisting = false;
        
        return state.adapters.add(persistentAdapter)
            .then(function(){
                return state.get(constants.State.NoCard);
            })
            .then(function(noCardState){
                if (noCardState && noCardState[0] && noCardState[0].value) {
                    isDebug = true;
                }

                useExisting = me.useExisting;

                if (isDebug) {
                    return Ctor.METHOD_TYPE_NO_CARD;
                }
                else if (useExisting) {
                    return Ctor.METHOD_TYPE_EXISTING;
                }
                else {
                    return Ctor.METHOD_TYPE_DEFAULT;
                }
            });
    };
    Ctor.instance = new Ctor;
    return Ctor;
});
